/* jshint ignore:start */
import React from "react";
import ReactDOM from "react-dom";
import { CSSTransition } from "react-transition-group";

import Backdrop from "./Backdrop";
import "./Modal.css";

const ModalOverlay = (props) => {
  console.log(props);
  const { image, onCancel } = props;
  const content = (
    <div className="modal">
      <button
        type="button"
        className="close"
        data-dismiss="modal"
        onClick={onCancel}>
        &times;
      </button>
      <div className="header">Picture</div>
      <div className="modal__content">
        <img src={image} alt="img" className="img" />
      </div>
    </div>
  );
  return ReactDOM.createPortal(content, document.getElementById("modal-hook"));
};

const Modal = (props) => {
  const { show, onCancel } = props;
  return (
    <React.Fragment>
      {show && <Backdrop onClick={onCancel} />}
      <CSSTransition
        in={props.show}
        mountOnEnter
        unmountOnExit
        timeout={200}
        className="modal">
        <ModalOverlay {...props} />
      </CSSTransition>
    </React.Fragment>
  );
};

export default Modal;
